import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLabels from 'ds/components/Table/Row/CellLabels'
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

const IntegrationsAiTableModelCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={item.modelDetails.map((model) => model.name)} />
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableModelCell;
